<template>
  <div class="footer">
    <div class="footer-top">
      <div class="about">
        <div class="about-tlt">{{ footInfo.FOOT_ABOUNT?.TITLE }}</div>
        <div
            class="about-item"
            v-for="(item, index) in footInfo.FOOT_ABOUNT?.children"
            :key="index"
            @click="goPath(item.externalLink)"
        >
          {{ item.message }}
        </div>
      </div>
      <!--    <div class="gang"></div>-->
      <div class="snkp">
        <div class="snkp-tlt">{{ footInfo.FOOT_ONLINE_SERVICE?.TITLE }}</div>
        <div
            class="snkp-item"
            v-for="(item, index) in footInfo.FOOT_ONLINE_SERVICE?.children"
            :key="index"
        >
          <div class="snkp-itemtlt">{{ item.TITLE }}</div>
          <div
              class="snkp-itemtlt"
              @click="openUrl(item.PAGE_PLATE_CONFIG_CONTENT.externalLink)"
          >
            {{ item.PAGE_PLATE_CONFIG_CONTENT.message }}
          </div>
        </div>
      </div>
      <!--    <div class="gang"></div>-->
      <div class="qrcode">
        <div class="qrcode-tlt">{{ footInfo.FOOT_MEDIA_PLATFORM?.TITLE }}</div>
        <div class="code-list">
          <div
              class="code-item"
              v-for="(item, index) in footInfo.FOOT_MEDIA_PLATFORM?.children"
              :key="index"
          >
            <img
                class="code-pic"
                :src="$urlImg(item.PAGE_PLATE_CONFIG_CONTENT)"
                alt=""
            />
            <div class="code-tlt">{{ item.TITLE }}</div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="hengxian"></div>-->
    <div class="banquaninfo">
      <div class="banquan">
        {{ footInfo.FOOT_ICP?.COPYRIGHT }}&nbsp;&nbsp;
        <span style="cursor: pointer" @click="goUrl">{{
          footInfo.FOOT_ICP?.policeICP?.message
        }}</span>
        <span @click="goUrl2">
          &nbsp;&nbsp;
          {{ footInfo.FOOT_ICP?.TECHNOLOGY_COMPANY?.message }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { aboutModuleInfo } from "@/api/index";
export default {
  name: "TheFooter", // 或者任何你喜欢的多词名称
  data() {
    return {
      footInfo: {},
      aboutSnkp: [
        {
          tlt: "总机",
          mask: "400-XXX-XXX",
        },
        {
          tlt: "业务方式",
          mask: "400-XXX-XXX",
        },
        {
          tlt: "招聘邮箱",
          mask: "400-XXX-XXX",
        },
        {
          tlt: "地址",
          mask: "河南省郑州市计算机视觉实际上就是XXX",
        },
      ],
    };
  },
  created() {
    this.aboutModuleInfo();
  },
  methods: {
    openUrl(url) {
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
    goUrl2() {
      if (this.footInfo.FOOT_ICP.TECHNOLOGY_COMPANY.externalLink) {
        window.open(
          this.footInfo.FOOT_ICP.TECHNOLOGY_COMPANY.externalLink,
          "_blank",
          "noopener,noreferrer"
        );
      }
    },
    goUrl() {
      if (this.footInfo.FOOT_ICP.policeICP.externalLink) {
        window.open(
          this.footInfo.FOOT_ICP.policeICP.externalLink,
          "_blank",
          "noopener,noreferrer"
        );
      }
    },
    aboutModuleInfo() {
      aboutModuleInfo({
        language: localStorage.getItem("lang"),
        moduleCode: "COMMON",
      }).then((res) => {
        if (res.code == 200) {
          this.footInfo = res.data.PAGE_FOOT;
        }
      });
    },
    goPath(url) {
      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  //height: 446px;
  background: #272727;
  padding: 18px 200px 18px 200px;
  //display: flex;
  position: relative;
  .footer-top{
    width: 100%;
    display: flex;
  }
  .about {
    flex: 1;
    width:33.333%;
    //margin-right: 388px;
    .about-tlt {
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 700;
      font-size: 18px;
      color: #ffffff;
      //line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 24px;
    }
    .about-item {
      font-family: Abhaya Libre, Abhaya Libre;
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      //line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 20px;
      cursor: pointer;
    }
  }
  .gang {
    width: 0;
    height: 348px;
    border: 1px solid rgba(172, 172, 172, 0.6);
    margin-right: 36px;
  }
  .snkp {
    flex: 1;
    width:33.333%;
    // max-width: 234px;
    //margin-right: 220px;
    border-left: 2px solid rgba(172, 172, 172, 0.6);
    padding-left: 36px;
    .snkp-tlt {
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 700;
      font-size: 18px;
      color: #ffffff;
      //line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 24px;
    }
    .snkp-item {
      width: 100%;
      margin-bottom: 20px;
      .snkp-itemtlt {
        font-family: Abhaya Libre, Abhaya Libre;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        //line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }
  }
  .qrcode {
    flex: 1;
    border-left: 2px solid rgba(172, 172, 172, 0.6);
    padding-left: 36px;
    width:33.333%;
    .qrcode-tlt {
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 700;
      font-size: 18px;
      color: #ffffff;
      //line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 17px;
    }
    .code-list {
      display: flex;
      .code-item {
        flex: 1;
        width: 50%;
        //height: 160px;
        text-align: center;
        //margin-right: 55px;
        .code-pic {
          width: 136px;
          height: 136px;
          display: block;
          margin:0 auto 15px;
        }
        .code-tlt {
          font-family: Microsoft YaHei UI, Microsoft YaHei UI;
          font-weight: 400;
          font-size: 14px;
          color: #a4a4a4;
          //line-height: 18px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
  .hengxian {
    width: 1446px;
    height: 0;
    border: 1px solid rgba(172, 172, 172, 0.6);
    position: absolute;
    left: 240px;
    bottom: 80px;
  }
  .banquaninfo {
    width: 100%;
    border-top: 2px solid rgba(172, 172, 172, 0.6);
    padding-top: 20px;
    margin-top: 20px;
    //position: absolute;
    //bottom: 29px;
    //left: 0;
    // padding: 0 240px;
    .banquan {
      width: fit-content;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      //line-height: 20px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 0 auto;
      // padding-left: 441px;
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .code-item {
    .code-pic {
      width: 136px !important;
      height: 136px !important;
      margin-bottom: 12px;
    }
  }
  .about-tlt {
    font-size: 28px !important;
  }
  .about-item {
    font-size: 20px !important;
  }
  .snkp-tlt {
    font-size: 28px !important;
  }
  .snkp-itemtlt {
    font-size: 20px !important;
  }
  .banquan {
    font-size: 28px !important;
  }
}
</style>